import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const Ctx = createContext(null);
const API = process.env.NODE_ENV === 'development'
  ? 'http://localhost:8002/api/v1/driver'
  : '/api/v1/driver';

export function DriverAuthProvider({ children }) {
  const [driver,  setDriver]  = useState(null);
  const [token,   setToken]   = useState(() => localStorage.getItem('drv_token') || null);
  const [loading, setLoading] = useState(true);

  const apiCall = useCallback(async (path, opts = {}) => {
    const headers = { 'Content-Type': 'application/json' };
    if (token) headers['Authorization'] = `Bearer ${token}`;
    const res = await fetch(`${API}${path}`, { headers, ...opts });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw Object.assign(new Error(data.detail || 'خطأ'), { status: res.status, data });
    return data;
  }, [token]);

  // Load profile on mount / token change
  useEffect(() => {
    if (!token) { setLoading(false); return; }
    apiCall('/auth/me')
      .then(d => setDriver(d))
      .catch(() => { localStorage.removeItem('drv_token'); setToken(null); })
      .finally(() => setLoading(false));
  }, [token]);

  const saveLogin = (tokens, driverData) => {
    localStorage.setItem('drv_token', tokens.access_token);
    localStorage.setItem('drv_refresh', tokens.refresh_token);
    setToken(tokens.access_token);
    setDriver(driverData);
  };

  const logout = () => {
    localStorage.removeItem('drv_token');
    localStorage.removeItem('drv_refresh');
    setToken(null);
    setDriver(null);
  };

  const refreshDriver = async () => {
    try {
      const d = await apiCall('/auth/me');
      setDriver(d);
      return d;
    } catch { logout(); }
  };

  return (
    <Ctx.Provider value={{
      driver, token, loading,
      isAuthenticated: !!driver && !!token,
      apiCall, saveLogin, logout, refreshDriver,
      setDriver,
    }}>
      {children}
    </Ctx.Provider>
  );
}

export const useDriverAuth = () => useContext(Ctx);
